<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.affiliate.list') }}
      </h1>

      <div class="card rounded-0 mb-4">
        <form class="card-body">
          <div class="row mb-2">
            <!-- Distributor -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedDistributorRef') }} *
              </label>
              <select
                v-model="criterias.selectedDistributorRef"
                :disabled="isDistributorLocked"
                :class="status(v$.criterias.selectedDistributorRef)"
                name="distributor"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.affiliate.selectedDistributorRef')"
                @change="updateComProducts()"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.affiliate.selectedDistributorRef') }}
                </option>
                <option
                  v-for="distributor in distributors"
                  :key="distributor.id"
                  :value="distributor"
                >
                  {{ distributor }}
                </option>
              </select>
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedDistributorRef.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
              </p>
            </div>

            <!-- Produit commercial -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedCommercialProduct') }}
              </label>
              <select
                v-model="criterias.selectedCommercialProduct"
                :class="status(v$.criterias.selectedCommercialProduct)"
                name="commercialProduct"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.affiliate.selectedCommercialProduct')"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.affiliate.selectedCommercialProduct') }}
                </option>
                <option
                  v-for="product in comProducts"
                  :key="product.id"
                  :value="product"
                >
                  {{ product }}
                </option>
              </select>
            </div>

            <!-- Statut contrat affilié -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedAffiliateStatus') }}
              </label>
              <select
                v-model="criterias.selectedAffiliateStatus"
                :class="status(v$.criterias.selectedAffiliateStatus)"
                name="affiliateStatus"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.affiliate.selectedAffiliateStatus')"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.affiliate.selectedAffiliateStatus') }}
                </option>
                <option value />
                <option
                  v-for="type in affiliateStatus"
                  :key="type.id"
                  :value="type"
                >
                  {{ type }}
                </option>
              </select>
            </div>

            <!-- Identifiant contrat affilié -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedContractId') }}
              </label>
              <input
                v-model="criterias.selectedContractId"
                :class="status(criterias.selectedContractId)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.affiliate.selectedContractId')"
              >
            </div>
          </div>

          <div class="row mb-2">
            <!-- Identifiant prestataire technique -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedProviderId') }}
              </label>
              <input
                v-model="criterias.selectedProviderId"
                :class="status(v$.criterias.selectedProviderId)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.affiliate.selectedProviderId')"
              >
            </div>

            <!-- Identifiant marchand -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedMerchantId') }}
              </label>
              <input
                v-model="criterias.selectedMerchantId"
                :class="status(v$.criterias.selectedMerchantId)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.affiliate.selectedMerchantId')"
              >
            </div>

            <!-- Date de création, du-->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedCreationDateStart') }}
              </label>
              <input
                v-model="criterias.selectedCreationDateStart"
                :class="status(v$.criterias.selectedCreationDateStart)"
                type="date"
                class="form-control rounded-0"
                placeholder="yyyy-MM-dd"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedCreationDateStart.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
              </p>
            </div>

            <!-- Au-->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedCreationDateEnd') }}
              </label>
              <input
                v-model="criterias.selectedCreationDateEnd"
                :class="status(v$.criterias.selectedCreationDateEnd)"
                type="date"
                class="form-control rounded-0"
                placeholder="yyyy-MM-dd"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedCreationDateEnd.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
              </p>
            </div>
          </div>
          <div class="row mb-2">
            <!-- Date de fermeture, du-->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedClosingDateStart') }}
              </label>
              <input
                v-model="criterias.selectedClosingDateStart"
                :class="status(v$.criterias.selectedClosingDateStart)"
                type="date"
                class="form-control rounded-0"
                placeholder="yyyy-MM-dd"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedClosingDateStart.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
              </p>
            </div>

            <!-- Au-->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.selectedClosingDateEnd') }}
              </label>
              <input
                v-model="criterias.selectedClosingDateEnd"
                :class="status(v$.criterias.selectedClosingDateEnd)"
                type="date"
                class="form-control rounded-0"
                placeholder="yyyy-MM-dd"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedClosingDateEnd.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
              </p>
            </div>

            <div class="col justify-content-end text-end criteria-button">
              <button
                type="button"
                class="btn btn-default btn-reset rounded-pill font-custom me-2"
                @click="reset()"
              >
                {{ $t('button.reset') }}
              </button>
              <button
                class="btn btn-primary btn-submit rounded-pill font-custom text-uppercase font-inverted"
                type="button"
                @click="search()"
              >
                <i class="fa fa-search me-1" />
                {{ $t('button.search') }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div v-if="$store.state.affiliates.affiliates.length">
        <div class="table-responsive">
          <table
            class="table table-hover table-sm table-striped border"
            style="white-space:nowrap;"
          >
            <thead>
              <tr>
                <th>Id contrat affilié</th>
                <th>Id distributeur</th>
                <th>Id produit</th>
                <th>Statut</th>
                <th>{{ $t('label.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="affiliate in displayedAffiliates"
                :key="affiliate.id"
                class="mb-3"
              >
                <td>{{ affiliate.contractId }}</td>
                <td>{{ affiliate.distributorId }}</td>
                <td>{{ affiliate.productId }}</td>
                <td>{{ affiliate.contractStatus }}</td>
                <td>
                  <button
                    v-if="hasPermission('affiliates:read')"
                    type="button"
                    class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom me-2"
                    @click="showDetails(affiliate)"
                  >
                    {{ $t('button.consult') }}
                  </button>
                  <button
                    v-if="hasPermission('affiliates:write')"
                    type="button"
                    class="btn btn-primary btn-sm rounded-pill font-custom"
                    @click="editAffiliate(affiliate)"
                  >
                    {{ $t('button.edit') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <Pager
          :posts="$store.state.affiliates.affiliates"
          @page-update="displayedAffiliates = $event;"
        />
      </div>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="center-block lazyload"
        >
      </div>

      <div
        v-else-if="error"
        class="alert alert-warning text-center border-0 shadow-sm rounded-0"
      >
        {{ $t('error.'+`${responseErr}`) }}
      </div>
    </div>
  </div>
</template>

<script src="./AffiliateList.js"></script>

<style src="./AffiliateList.scss" scoped lang="scss"></style>
